/**
 * The morning brief's sections, as a value.
 *
 * Here rather than beside the API types because the URL reads it: a question
 * handed over from the brief names its section in the query string
 * (`useAgentUrl`), and a section this version does not know is dropped rather
 * than sent for the server to refuse. Modules under `apis/` are mocked whole in
 * component tests, so a constant living there would be `undefined` in every
 * suite that never meant to talk about the brief at all.
 */
export const BRIEF_SECTION_KEYS = [
  'safety',
  'scheduleChanges',
  'issues',
  'activityVsPlan',
  'todaySchedule',
  'weather',
] as const;

export type BriefSectionKey = (typeof BRIEF_SECTION_KEYS)[number];

/**
 * Sections only ONE reader's brief carries — today, their own floor, when their
 * instruction names one. Not in `BRIEF_SECTION_KEYS` on purpose: that list is
 * the site's sections, which is what the mutes and the settings dialog walk, and
 * a reader cannot mute the floor they asked for.
 */
export const READER_SECTION_KEYS = ['floorFocus', 'lookups'] as const;

/** Any section a reader's brief can carry — what a line, an insight or a question can name. */
export type AiBriefSectionKey = BriefSectionKey | (typeof READER_SECTION_KEYS)[number];

export const ALL_SECTION_KEYS: readonly AiBriefSectionKey[] = [...BRIEF_SECTION_KEYS, ...READER_SECTION_KEYS];

/**
 * The server's cap on a brief instruction (`MAX_BRIEF_INTEREST_LENGTH`). One
 * constant for both places a reader edits one — the settings form and the
 * assistant's proposal card — so they cannot disagree on what fits.
 */
export const MAX_BRIEF_INSTRUCTION_LENGTH = 800;
